import React from 'react'
import DOMPurify from 'dompurify'
import { makeStyles, useTheme } from '@material-ui/core'
import { richTextViewerStyle } from './richTextViewer.styles'

type RichTextViewerProps = {
  content: string // rich HTML content to display SANITIZED in case of sql data manipulation by other API
}

/**
 * RichTextViewer component is used to display rich HTML content in a sanitized way.
 * @props content - current HTML string content fetched from service.
 * @returns div with sanitized HTML content in standard react format
 */
export const RichTextViewer: React.FC<RichTextViewerProps> = ({ content }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(richTextViewerStyle(currentTheme))
  const classes = useStyles()

  const sanitizedHTML = DOMPurify.sanitize(content)

  return (
    <div dangerouslySetInnerHTML={{ __html: sanitizedHTML }} className={classes.richTextViewer} />
  )
}
